// src/encounter/lib/template-axes.ts
// Build the 4 BFF request axes (contract PROD-1155). practitionerId + age are sourced
// locally; specialtyId + gender(value-set id) come from `resolved` — the seam for the
// two open sourcing items (preconditions 2,3 → PROD-1162). Until those are wired,
// callers pass them explicitly (or omit → undefined). All axes are OPTIONAL: a null/
// absent axis is unconstrained on the BFF (returns matching + Default set, never 400).
import type { UserData } from '@/auth/types';

export interface TemplateAxes {
  specialtyId?: string;
  practitionerId?: string;
  gender?: string; // MasterManagement gender value-set id (NOT 'M'/'F')
  age?: number;
  /** TS-4 (PROD-2820): the appointment type code (ROUTINE / FOLLOWUP / WALKIN). */
  visitType?: string;
  /** TS-4: the booked appointment profile id — ignored by the BFF in phase 1, resolved in phase 2. */
  appointmentProfileId?: string;
}

export interface ResolvedAxisData {
  specialtyId?: string; // precondition 2 (PROD-1162)
  genderId?: string;    // precondition 3 (PROD-1162)
  visitType?: string;   // TS-4 — lib/booked-visit-type.ts
  appointmentProfileId?: string; // TS-4 — phase-2 input
}

export function toTemplateAxes(
  user: Pick<UserData, 'id'> | null | undefined,
  demographics: { age?: number; sex?: string } | undefined,
  resolved: ResolvedAxisData,
): TemplateAxes {
  return {
    practitionerId: user?.id,        // = doctorSetupId (contract)
    age: demographics?.age,
    specialtyId: resolved.specialtyId,
    gender: resolved.genderId,
    // Only set when known, so an existing caller's axes object (and its query key) is unchanged.
    ...(resolved.visitType ? { visitType: resolved.visitType } : {}),
    ...(resolved.appointmentProfileId ? { appointmentProfileId: resolved.appointmentProfileId } : {}),
  };
}
